import { render } from "./Search.vue?vue&type=template&id=16ccdf41"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"
script.render = render

export default script